"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeatureFlag = void 0;
const client_1 = require("@apollo/client");
const react_1 = require("react");
const utils_1 = require("@10xlabs/utils");
const useFeatureFlag = (featureFlagName) => {
    const featureFlagsInstance = (0, react_1.useContext)(utils_1.FeatureFlagsContext);
    const value = (0, client_1.useReactiveVar)(featureFlagsInstance.getValue(featureFlagName));
    const setValue = (value) => {
        featureFlagsInstance.setValue(featureFlagName, value);
    };
    return [value, setValue];
};
exports.useFeatureFlag = useFeatureFlag;
//# sourceMappingURL=use-feature-flag.js.map